import { render, staticRenderFns } from "./MaestrosPqr.vue?vue&type=template&id=6a4cc771"
import script from "./MaestrosPqr.vue?vue&type=script&lang=js"
export * from "./MaestrosPqr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports